import templateUrl from './edit-feedback.component.html'

const starRatings = [{
    rating: 1,
    text: "Very unsatisfied"
}, {
    rating: 2,
    text: "Somewhat unsatisfied"
}, {
    rating: 3,
    text: "Average"
}, {
    rating: 4,
    text: "Good"
}, {
    rating: 5,
    text: "Great"
}]

export const EditFeedbackComponent = {
    templateUrl,
    bindings: {
        feedback: "<"
    },
    controllerAs: "vm",
    controller: class EditFeedbackComponent {
        constructor() {
            this.starRatings = starRatings
        }

        onGetCssClass(rating) {

            const comparedRating = this.hoveredRating || this.feedback.rating;
            return {
                'far fa-star': !comparedRating || rating.rating > comparedRating.rating,
                'fas fa-star': comparedRating && rating.rating <= comparedRating.rating,
                'text-bad': comparedRating && rating.rating <= comparedRating.rating && comparedRating.rating < 2,
                'text-success': comparedRating && rating.rating <= comparedRating.rating && comparedRating.rating > 4,
            }
        }
    }
}
